import { compact, compose, flatMap } from 'lodash/fp';
import { SupportedPaymentMethod } from '@mews/enums';
import { PaymentCardImageTypes } from '@mews/framework/payments';
import { createHandler } from '@mews/std';
import { PaymentMethodImageType } from '../PaymentMethodImage';

const supportedPaymentMethodToPaymentMethodImage = createHandler<
    Exclude<SupportedPaymentMethod, SupportedPaymentMethod.PaymentCard>,
    PaymentMethodImageType | null
>(
    {
        [SupportedPaymentMethod.Ideal]: PaymentMethodImageType.Ideal,
        [SupportedPaymentMethod.ApplePay]: PaymentMethodImageType.ApplePay,
        [SupportedPaymentMethod.GooglePay]: PaymentMethodImageType.GooglePay,
    },
    null
);

interface GetSupportedImageTypes {
    cardTypes: Array<keyof PaymentCardImageTypes>;
    paymentMethods: Array<SupportedPaymentMethod>;
}

export const getSupportedImageTypes = ({ cardTypes, paymentMethods }: GetSupportedImageTypes) =>
    compose(
        compact,
        flatMap<SupportedPaymentMethod, PaymentMethodImageType | keyof PaymentCardImageTypes | null>((method) =>
            method === SupportedPaymentMethod.PaymentCard
                ? cardTypes
                : supportedPaymentMethodToPaymentMethodImage(method)
        )
    )(paymentMethods);
